import {FormattedMessage, injectIntl} from '@meiko/react-intl';
import PanelHeaderTitle from 'components/generic/PanelHeaderTitle';
import Panel from 'components/generic/Panel';
import useWindowWidth from 'hooks/windowWidth';
import React from 'react';
import Chart from 'react-chartjs-2';
import {compose} from 'redux';
import {currencyOptions} from 'utils/numberFormat';

const SalesChart = ({data, intl}) => {
	const {width: windowWidth} = useWindowWidth();

	const datasByType = data.reduce((acc, row) => {
		(row?.values ?? []).forEach(({label, value}) => {
			const cur = acc[label] ?? [];
			acc[label] = [...cur, value];
		});
		return acc;
	}, {});

	const budgetSum = data.reduce((acc, entry) => acc + entry.budget, 0);
	const targetSum = data.reduce((acc, entry) => acc + entry.target, 0);

	const options = {
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: false,
			},
		},
		maintainAspectRatio: false,
		plugins: {
			tooltip: {
				callbacks: {
					label: function (context) {
						return ` ${intl.formatNumber(context.raw, currencyOptions)}`;
					},
				},
			},
		},
	};

	const chartData = {
		labels: data.map(entry => entry.columnLabel),
		datasets: [
			{
				type: 'line',
				label: `${intl.formatMessage({id: 'Dashboard target'})} (${intl.formatNumber(
					targetSum,
					currencyOptions,
				)})`,
				borderColor: 'rgb(255, 99, 132)',
				borderWidth: 2,
				fill: false,
				data: data.map(entry => entry.target),
				datalabels: {
					display: false,
				},
			},
			...Object.keys(datasByType).map((key, index) => {
				const d = datasByType[key];
				const total = d.reduce((acc, cur) => acc + cur, 0);
				return {
					type: 'bar',
					label: `${key} (${intl.formatNumber(total, currencyOptions)})`,
					backgroundColor: `rgba(75, 192, 192, ${1 - index * 0.2})`,
					data: d,
					borderColor: 'transparent',
				};
			}),
			{
				type: 'bar',
				label: `${intl.formatMessage({id: 'Budget'})} (${intl.formatNumber(
					budgetSum,
					currencyOptions,
				)})`,
				borderColor: 'rgb(254, 153, 0)',
				borderWidth: 2,
				data: data.map(entry => entry.budget),
				datalabels: {
					display: false,
				},
			},
		],
	};
	return (
		<Panel
			header={
				<PanelHeaderTitle>
					<FormattedMessage id="Sales target - realization" />
				</PanelHeaderTitle>
			}
		>
			<Chart
				type="bar"
				height={windowWidth > 800 ? 300 : 250}
				data={chartData}
				options={options}
			/>
		</Panel>
	);
};

export default compose(injectIntl)(SalesChart);
